// Exact Figma export (Lucide, 2px stroke on a 24px grid). Stroke colour is a prop.
function PaywallCircleX({ dimensions, col = '#fff' }) {
  return `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.0002 8.99976L8.99976 15.0002M8.99976 8.99976L15.0002 15.0002M22.0008 12C22.0008 17.5233 17.5233 22.0008 12 22.0008C6.47671 22.0008 1.9992 17.5233 1.9992 12C1.9992 6.47671 6.47671 1.9992 12 1.9992C17.5233 1.9992 22.0008 6.47671 22.0008 12Z" stroke="${col}" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `;
}

export default PaywallCircleX;
